export function calculateAge(birthDate: string): number {
  const timeDifference: number = Math.abs(new Date().getTime() - new Date(birthDate).getTime());
  return Math.floor(timeDifference / (1000 * 3600 * 24) / 365.25);
}
